import { useTranslation } from 'react-i18next';
import { Badge } from '@/shared/components/ui/Badge';
import { Card, CardContent } from '@/shared/components/ui/Card';
import { Target } from 'lucide-react';
import type { EmployeePopulatedGoalIssue } from '@momentum/types';
import { IssueStatus } from '@momentum/types';

interface GoalSummaryCardProps {
  goal: EmployeePopulatedGoalIssue;
}

const statusI18nMap: Record<string, string> = {
  [IssueStatus.TODO]: 'statusTodo',
  [IssueStatus.IN_PROGRESS]: 'statusInProgress',
  [IssueStatus.COMPLETED]: 'statusCompleted',
};

export const GoalSummaryCard = ({ goal }: GoalSummaryCardProps) => {
  const { t } = useTranslation('goals');

  const statusKey = statusI18nMap[goal.status] || goal.status;

  return (
    <Card className="border-slate-200 bg-white shadow-sm transition-shadow hover:shadow-md">
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          {/* Goal Icon */}
          <div className="shrink-0 rounded-lg bg-primary/10 p-2">
            <Target className="h-5 w-5 text-primary" />
          </div>

          {/* Goal Content */}
          <div className="flex flex-row items-center justify-around min-w-0 flex-1">
            {/* Goal Title */}
            <h3 className="text-base font-semibold text-slate-900 line-clamp-2">
              {goal.title}
            </h3>

            {/* Status Badge */}
            <div className="flex flex-wrap items-center gap-2">
              <Badge
                className="flex items-center gap-1.5 border-slate-200 bg-slate-50 text-slate-700"
                variant="outline"
              >
                {t(statusKey as any)}
              </Badge>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
